<template>
  <div class="flexSpaceBetweenRow topNav">
    <div class="flexLeftRow">
      <NavButton
        text="Workflow"
        :icon="Zap"
        :icon_size="'20'"
        :isSelected="currentBoard == 'workflow'"
        @click="changeBoard('workflow')"
      />
      <NavButton
        text="Statistics"
        :icon="ChartColumnStacked"
        :icon_size="'20'"
        :isSelected="currentBoard == 'statistics'"
        @click="changeBoard('statistics')"
      />
      <!-- <NavButton
        text="Logs"
        :icon="Logs"
        :icon_size="'20'"
        :isSelected="currentBoard == 'logs'"
        @click="changeBoard('logs')"
      /> -->
    </div>
    <div class="flexLeftRow">
      <div class="topnavbtn" @click="copyToClipboard()">
        <div class="topnavtnHover">
          <ArrowDownToLine size="18" />
        </div>
      </div>
      <div class="topnavbtn" @click="togglechat()">
        <div class="topnavtnHover">
          <MessageSquare size="18" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
import {
  ChartColumnStacked,
  Zap,
  Logs,
  MessageSquare,
  ArrowDownToLine,
} from "lucide-vue-next";
import routerPush from "../../utilities";
// import BaseButton from "@/components/buttons/BaseButton.vue";
import NavButton from "@/components/buttons/NavButton.vue";

export default {
  name: "TopNav",
  props: {
    currentBoard: {
      type: String,
      default: "workflow",
    },
    nodes: {
      type: Array,
      default: () => [],
    },
    edges: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    NavButton,
    MessageSquare,
    ArrowDownToLine,
    // BaseButton,
    //lucide
    // MessagesSquare,
  },
  methods: {
    changeBoard(board) {
      this.$emit("changeBoard", board);
    },
    togglechat() {
      this.$emit("togglechat");
    },
    async copyToClipboard() {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = JSON.stringify([this.nodes, this.edges]);
      console.log(this.nodes);
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },
  },
  setup() {
    return {
      routerPush,
    };
  },
  data() {
    return {
      // navItems: ['New workflow', 'WorkflowList', 'Logs', 'Dashboard'],
      ChartColumnStacked,
      Zap,
      Logs,
    };
  },
};
</script>

<style scoped>
.topNav {
  height: 50px;
  background: #f9f4ff;
  border-bottom: thin solid lightgray;
  width: calc(100vw - 51px);
  margin-left: 51px;
}
.topnavbtn {
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: thin solid lightgray;
  cursor: pointer;
}
.topnavtnHover {
  height: 35px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
}
.topnavbtn:hover .topnavtnHover {
  background: #dadada;
}
</style>
